import z from 'zod';
import { AGE, GENDER, MATCHED_TYPE, RACE, SOURCE_PLATFORM_TYPE } from '../public-filter';

export const DemographicSchema = z
  .object({
    age: z.array(z.enum(AGE)).optional().nullable(),
    gender: z.array(z.enum(GENDER)).optional().nullable(),
    race: z.array(z.enum(RACE)).optional().nullable(),
    location: z.array(z.string()).optional().nullable(), // ISO-3166-1 alpha 2
    language: z.array(z.string()).optional().nullable(), // ISO-639-1
  })
  .optional()
  .nullable();

export const EngagementSchema = z
  .object({
    followers_min: z.number().optional().nullable(),
    followers_max: z.number().optional().nullable(),
    er_min: z.number().optional().nullable(),
    er_max: z.number().optional().nullable(),
  })
  .optional()
  .nullable();

export const CreatorFilterSchema = z.object({
  start_date: z.string(),
  end_date: z.string(),
  platform: z.array(z.enum(SOURCE_PLATFORM_TYPE)).nullable(),
  demographics: DemographicSchema,
  engagement: EngagementSchema,
  official_account_only: z.boolean().optional().nullable(),
});

export const SearchObjectSchema = z.object({
  filter_conditions: CreatorFilterSchema,
  video_feature_conditions: z.array(z.string()).optional().nullable(),
  post_content_conditions: z.array(z.string()).optional().nullable(),
});

export const SearchCreatorRequestSchema = z.object({
  prompt: z.string(),
  analyzed_result: SearchObjectSchema,
});

// @DESIGN_FLAG: 디자인 단계에서 lookalike 응답을 "프롬프트 3개 추천" 대신 "키워드 추출" 계약으로 임시 전환한다.
// 실제 백엔드 계약이 확정되면 creators/lookalike-suggestions 엔드포인트와 entity schema를 production API 명세에 맞게 교체하고,
// 현재 keywords/selection_limit 구조와 mock handler 의존성을 제거해야 한다. 제거 시점은 lookalike 검색 API 연동 완료 후다.
export const LookalikeKeywordSchema = z.object({
  id: z.string(),
  label: z.string(),
});

export const LookalikeKeywordExtractionRequestSchema = z.object({
  selected_post_ids: z.array(z.string()).min(1),
  original_search_request: SearchCreatorRequestSchema,
});

export const LookalikeKeywordExtractionResponseSchema = z.object({
  keywords: z.array(LookalikeKeywordSchema),
  selection_limit: z.number().int().min(1),
});

export const CreatorContentSchema = z.object({
  id: z.string(),
  poster_url: z.string(),
  video_url: z.string(),
  source_url: z.string(),
  content: z.string(),
  ai_matched_features: z.array(z.string()).optional().nullable(),
  engagement: z.object({
    view: z.number(),
    like: z.number(),
    comment: z.number(),
    rate: z.number(),
    shared: z.number(),
  }),
  date: z.string(),
});

export const CreatorSchema = z.object({
  creator_id: z.string(),
  search_id: z.string(),
  match_type: z.enum(MATCHED_TYPE),
  post_categories: z.array(z.string()),
  is_saved: z.boolean(),
  saved_at: z.string().optional(),
  platform: z.enum(SOURCE_PLATFORM_TYPE),
  username: z.string(),
  nickname: z.string(),
  profile_image_url: z.string(),
  followers: z.number(),
  average_er: z.number(),
  matched_keywords: z.array(z.string()),
  matched_posts: z.array(CreatorContentSchema),
  matched_post_ids: z.array(z.string()),
  excluded_date: z.string(),
});

export const exportCreatorListRequestSchema = z.union([
  z.object({
    search_id: z.string(),
    selected_all: z.boolean(),
  }),
  z.object({
    creator_ids: z.array(z.string()).optional(),
    selected_all: z.boolean(),
  }),
]);

export const FetchCreatorByCacheIdRequestSchema = z.object({
  attempt: z.int().min(1),
  show_saved: z.boolean().optional().default(false),
  full_matched_only: z.boolean().optional().default(false),
});
